import Parse from "parse";

import type { Ticket } from "./Ticket";
import type { _User } from "./_User";

type OD3_Tenant = Parse.Object;

export interface Ticket_TitleAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  tenant?: OD3_Tenant;
  ticket: Ticket;
  title?: string;
  user: _User;
}

export class Ticket_Title extends Parse.Object<Ticket_TitleAttributes> {
  static className: string = "OD3_Maintenance_Ticket_Title";

  constructor(data?: Partial<Ticket_TitleAttributes>) {
    super("OD3_Maintenance_Ticket_Title", data as Ticket_TitleAttributes);
  }

  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get ticket(): Ticket {
    return super.get("ticket");
  }
  set ticket(value: Ticket) {
    super.set("ticket", value);
  }
  get title(): string | undefined {
    return super.get("title");
  }
  set title(value: string | undefined) {
    super.set("title", value);
  }
  get user(): _User {
    return super.get("user");
  }
  set user(value: _User) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Ticket_Title", Ticket_Title);
